import { Dropdown, DropdownList, Input } from '@cokitchen/cokitchen-components';
import { CalendarIcon } from 'cokitchen-icons';
import useNewCareerPositionContext from 'contexts/career-position.context';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';

const CreateApplicationSettings = () => {
  const { createJobPositionForm, setCreateJobPositionForm, setDisabled } =
    useNewCareerPositionContext();
  const [openCalendar, setOpenCalendar] = useState(true);

  useEffect(() => {
    const disabled = ![
      createJobPositionForm.applicationDeadline,
      createJobPositionForm.noOfOpenings
    ].every(Boolean);

    setDisabled(disabled);
  }, [createJobPositionForm]);
  return (
    <div className='space-y-4'>
      <div>
        <p className='font-medium text-base mb-2'>Application deadline</p>
        <Dropdown
          onClickOutside={() => setOpenCalendar(false)}
          content={
            <div
              onClick={() => setOpenCalendar(true)}
              className='flex justify-between items-center cursor-pointer border border-gray-1 rounded-md p-3 text-gray-6/40 font-medium bg-transparent'>
              <span
                className={`${
                  createJobPositionForm.applicationDeadline ? 'text-gray-6' : 'text-gray-6/40'
                }`}>
                {createJobPositionForm.applicationDeadline
                  ? moment(new Date(createJobPositionForm.applicationDeadline)).format(
                      'ddd MMM DD, yyyy'
                    )
                  : 'Select date'}
              </span>
              <CalendarIcon className='text-gray-6/40' />
            </div>
          }>
          <DropdownList className='!max-h-max bg-transparent p-0'>
            {openCalendar && (
              <DatePicker
                selected={
                  createJobPositionForm.applicationDeadline
                    ? new Date(createJobPositionForm.applicationDeadline)
                    : undefined
                }
                open
                inline
                minDate={new Date()}
                onChange={(date) => {
                  setCreateJobPositionForm({
                    ...createJobPositionForm,
                    applicationDeadline: moment(date).format('YYYY-MM-DDTHH:mm:ssZ')
                  });
                  setOpenCalendar(false);
                }}
              />
            )}
          </DropdownList>
        </Dropdown>
      </div>
      <Input
        type='number'
        min='1'
        step='1'
        label='Number of openings'
        placeholder='Enter number of openings'
        className='w-full mt-4'
        inputClass='px-4 py-3'
        value={createJobPositionForm?.noOfOpenings || ''}
        onChange={(e) => {
          const numericValue = e.target.value.replace(/[^0-9]/g, '');
          setCreateJobPositionForm({
            ...createJobPositionForm,
            noOfOpenings: numericValue
          });
        }}
      />
    </div>
  );
};

export default CreateApplicationSettings;
